module.exports = __webpack_public_path__ + "img/spa-fitness.4b54b1ef.svg";